export class EventCode {
     public static patchDownloadInitiated = "DLOAD_INIT";
    public static patchDownloadStarted = 'DLOAD_START';
    public static patchDownloadInprogress = 'DLOAD_PROGRESS';
    public static patchDownloadCompleted = 'DLOAD_COMPLETE';
    public static patchDownloadFailed = 'DLOAD_FAILED';
    public static patchDownloadTimedOut = 'DLOAD_TIMEOUT';
    public static patchDownloadCancelled = 'DLOAD_CANCEL';
    public static patchDownloadCancelledOld = 'Cancelled';
}